import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';

function getMonday(date) {
  const d = new Date(date);
  const day = d.getDay();
  const diff = d.getDate() - day + (day === 0 ? -6 : 1);
  d.setDate(diff);
  return d.toISOString().split('T')[0];
}

export default function QuotaFormModal({ farms, onClose, onSave, saving }) {
  const { t } = useTranslation();
  const [form, setForm] = useState({
    farm: farms[0]?.id || '',
    week_start: getMonday(new Date()),
    available_boxes: '',
    min_price: '',
    notes: '',
  });

  const handleSubmit = (e) => {
    e.preventDefault();
    onSave(form);
  };

  return (
    <div className="bmp-modal-overlay" onClick={onClose}>
      <div className="bmp-modal" onClick={e => e.stopPropagation()}>
        <div className="bmp-modal-header">
          <h3>{t('bmp_publish_quota')}</h3>
          <button className="bmp-modal-close" onClick={onClose}>&#10005;</button>
        </div>
        <form onSubmit={handleSubmit} className="bmp-modal-body" style={{ display: 'flex', flexDirection: 'column', gap: 12 }}>
          <div className="bmp-form-row">
            <div className="bmp-field">
              <label>{t('bmp_farm')}</label>
              <select value={form.farm} onChange={e => setForm(f => ({ ...f, farm: e.target.value }))} required>
                {farms.map(f => <option key={f.id} value={f.id}>{f.name} ({f.zone_display})</option>)}
              </select>
            </div>
            <div className="bmp-field">
              <label>{t('bmp_week')}</label>
              <input type="date" value={form.week_start} onChange={e => setForm(f => ({ ...f, week_start: e.target.value }))} required />
            </div>
            <div className="bmp-field">
              <label>{t('bmp_available_boxes')}</label>
              <input type="number" min="1" value={form.available_boxes} onChange={e => setForm(f => ({ ...f, available_boxes: e.target.value }))} required placeholder="0" />
            </div>
          </div>
          <div className="bmp-form-row">
            <div className="bmp-field">
              <label>{t('mkt_min_price')}</label>
              <input type="number" step="0.01" min="0" value={form.min_price} onChange={e => setForm(f => ({ ...f, min_price: e.target.value }))} placeholder={t('mkt_optional')} />
            </div>
            <div className="bmp-field">
              <label>{t('mkt_notes')}</label>
              <input type="text" value={form.notes} onChange={e => setForm(f => ({ ...f, notes: e.target.value }))} placeholder={t('mkt_notes_placeholder')} />
            </div>
          </div>
          <div className="bmp-form-actions">
            <button type="button" className="bmp-btn bmp-btn-secondary" onClick={onClose}>{t('cancel')}</button>
            <button type="submit" className="bmp-btn bmp-btn-primary" disabled={saving}>{saving ? t('saving') : t('bmp_publish')}</button>
          </div>
        </form>
      </div>
    </div>
  );
}
